export default __webpack_public_path__ + "static/media/zoomed_diagonaldown_darktolight.c37769b7.png";